module.exports = __webpack_public_path__ + "static/media/gift-1.1ac60fe7.png";